import { call, put } from "redux-saga/effects";
import { manageCatgoryConstants } from "../actions/constants/manageCategoryConstants";
import { exceptionHandler, exceptionHandlerForUpdate } from "../pages/common/functions";
import ManageCategoryService from "../services/api/manageCategoryService";

// For get all category & search result
function* manageCategoryGetAllCategory(request: any) {
	try {
		const result = yield call(
			ManageCategoryService.manageCategoryGetAll,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: manageCatgoryConstants.ManageCategoryGetByfilterSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: manageCatgoryConstants.ManageCategoryGetByfilterFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: manageCatgoryConstants.ManageCategoryGetByfilterFailure,
			payload: e,
		});
	}
}

// For update the category status
function* manageCategoryStatusUpdate(input: any) {
	try {
		const result = yield call(
			ManageCategoryService.manageCategoryStatusUpdate,
			input.input
		);
		const res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: manageCatgoryConstants.ManageCategoryUpdateStatusSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: manageCatgoryConstants.ManageCategoryUpdateStatusFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: manageCatgoryConstants.ManageCategoryUpdateStatusFailure,
			payload: e,
		});
	}
}

// For create category
function* manageCategoryCreate(input: any) {
	try {
		const result = yield call(
			ManageCategoryService.manageCategoryCreate,
			input.input
		);
		const res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: manageCatgoryConstants.ManageCategoryCreateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: manageCatgoryConstants.ManageCategoryCreateFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: manageCatgoryConstants.ManageCategoryCreateFailure,
			payload: e,
		});
	}
}

// For update category
function* manageCategoryUpdate(input: any) {
	try {
		const result = yield call(
			ManageCategoryService.manageCategoryUpdate,
			input.input
		);
		const res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: manageCatgoryConstants.ManageCategoryUpdateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: manageCatgoryConstants.ManageCategoryUpdateFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: manageCatgoryConstants.ManageCategoryUpdateFailure,
			payload: e,
		});
	}
}

// For delete category
function* manageCategoryDelete(request: any) {
	try {
		const result = yield call(
			ManageCategoryService.manageCategoryDelete,
			request.input
		);
		var res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: manageCatgoryConstants.ManageCategoryDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: manageCatgoryConstants.ManageCategoryDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: manageCatgoryConstants.ManageCategoryDeleteFailure,
			payload: error,
		});
	}
}

export const manageCategorySaga = {
	manageCategoryGetAllCategory,
	manageCategoryStatusUpdate,
	manageCategoryCreate,
	manageCategoryUpdate,
	manageCategoryDelete
};
